import React from 'react'
import '../../index.css'
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import final2 from '../../Assets/Img/final2.jpg'

const Chap33 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
        <Link to="/Chap32">Previous</Link>
        <Link to="/">Home</Link>
      </div>

      <h1 className='chapterHeading'>Chapter 33: Daniel’s Prophecy Unfulfilled</h1>

      <img src={final2} className='image' alt='Mormon conference center' />

    <div className="wrapper">

    <div className='paragraph'>
          <p>The early Mormons were promised in an 1832 revelation that in their lifetimes they would “… stand upon Mount Zion … which 
            temple, shall be reared in this generation.”  
            <btn id="clickable1" className="footnote">1 </btn>
            <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>D&C 97:19.</Tooltip>
            
            If a generation is 20 to 30 years,  
            <btn id="clickable2" className="footnote">2 </btn>
            <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>Jack Fenner, 28 March 2005, Cross-Cultural Estimation of the Human Generation Interval for Use in 
              Genetics-Based Population Divergence Studies, American Journal of Physical Anthropology. 128: 415-423.</Tooltip>
            
            the Mormons would establish Zion on the appointed spot in Jackson County between 1852 and 1862. As foretold in Joseph’s revelations, this would be the first domino to 
            fall in a line of soon to be events that would lead to the Second Coming. 
            Through their prophet, the early Mormons believed that in their lifetimes, biblical prophecies would be fulfilled. Great spiritual gifts would be poured out upon God’s 
            new chosen people – the Mormons. 
          </p>
        </div>

        <div className='paragraph'>
          <p>However, none of this came to pass!
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph had his followers believing that the holy city of Zion, the New Jerusalem, would be built in Jackson County as an ensign to gather the elect of the House of Israel 
            from the four corners of the earth. 
            The city would become alive with the glory of God. A pillar of fire would appear above it. You would be able to see the glory-filled city from miles and miles away. 
            The city would strike fear in the world. Christ would visit that city prior to his Second Coming. 
            </p>
            </div>
            
        <div className='paragraph'>
            <p>
            For the early Mormons, the day was fast approaching when the events 
            of John’s vision in the Book of Revelation would unfold across the globe. Then Christ would appear in his ultimate glory at his Second Coming. From Zion, the Mormons 
            would watch the world and its wickedness consumed in the fire of Christ’s presence, ushering in the great Millennial day where the Mormons would reign with Christ.
          </p>
        </div>

        <div className='paragraph'>
          <p>Early Mormons of the 1830s were promised they would live to see these events unfold. 
            Lyman Johnson was promised that “He shall see the Savior come and stand upon the earth with power and great glory.” 
          <btn id="clickable3" className="footnote">3 </btn>
          <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>Documentary History of the Church vol 2; p. 188.</Tooltip>
            
            Heber Kimball was promised that “He may stand unto the coming of our Lord.”  
            <btn id="clickable4" className="footnote">4 </btn>
            <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>Documentary History of the Church vol 2; p. 189.</Tooltip>
            
            Orson Hyde was promised “That he may stand upon the earth and bring souls till Christ comes.”  
            <btn id="clickable5" className="footnote">5 </btn>
            <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Documentary History of the Church vol 2; p. 190.</Tooltip>
            
            William Smith was blessed that “He shall be preserved and remain on the earth until Christ shall come to take vengeance on 
            the wicked.”  
            <btn id="clickable6" className="footnote">6 </btn>
            <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Documentary History of the Church vol 2; p. 191.</Tooltip>
            
            But none of this came to pass!
          </p>
        </div>

        <div className='paragraph'>
          <p>Speaking of the church he founded, Joseph Smith prophesied in 1834, “I want to say to you before the Lord, that you know no 
            more concerning the destinies of this Church and kingdom than a babe upon its mother’s lap. You don’t comprehend it. 
            This Church will fill North and South America – it will fill the world.” But this did not come to pass!
            <btn id="clickable7" className="footnote">7 </btn>
            <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>Wilford Woodruff, Conference Report, Apr. 1898, p. 57.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph built a grandiose latter-day vision in his followers. From the promises of their prophets, they believed millions of people would pour into the Mormon 
            church. First Presidency Counselor Heber Kimball stated, “Joseph the Prophet dedicated that land (Jackson County) … and 
            I shall yet see the day that I will go back there, with brother Brigham and with thousands and millions of others.”  
            <btn id="clickable8" className="footnote">8 </btn>
            <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Heber Kimball, Journal of Discourses, December 27, 1857, vol. 6, p. 190.</Tooltip>
             
            Speaking of the final great battles between the Mormons (Israel) and the wicked, First Presidency Counselor Daniel Wells 
            stated that there will be millions of Mormons in a mighty force fighting against the wicked nations. “There is need of every 
            faithful man and woman in this kingdom, and for millions more; and then, by concentrating all these efforts, it is easy to 
            understand what a mighty phalanx Israel will present, making the wicked nations tremble because of their wickedness.”
            <btn id="clickable9" className="footnote">9 </btn>
            <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>Daniel Wells, Journal of Discourses, October 7, 1859, vol. 7, p. 250.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Today, the church claims 17 million members. But that is a deception. Only an estimated four million members attend meetings – the true number of Mormons. 
            Yes, Mormonism is established in many countries, but it is far from Joseph’s prophetic projection. And where will membership numbers be in the next decade? 
            With four million members amongst a world population of eight billion, the Mormon Church today is a speck on a speck on a speck.
          </p>
        </div>

        <div className='paragraph'>
          <p>More bad news. Speaking as a former bishop, how many of those four million Mormons being counted every Sunday are converted believers? There are “active” members. 
            And then there are “engaged” members – the truly converted. Engaged members comprise a small number of people in the seats. As a Bishop I had a hard time getting 
            active members to do their callings or attend the temple. It was only a small group of engaged members who did all the work and attended the temple. A visiting general 
            authority in a training meeting called it the problem of the “same 10 injuns” (tone-deaf) encouraging us to engage more members. We tried. Couldn’t be done.
          </p>
        </div>

        <div className='paragraph'>
          <p>With a dwindling number of Mormons, and lackluster commitment from members, Mormonism is a dying religion no matter how hard the church tries to convince otherwise.
          </p>
        </div>

        <h2 className="headlinePadding" >The Weight of the Evidence</h2>

        <div className='paragraph'>
          <p>Given the weight of evidence staring Mormonism in the face in 2025, why would men claiming to speak for Christ, continue to perpetuate a 
            failed restoration going on 200 years now. Given the hundreds of issues with the authenticity of the Book of Mormon, Doctrine and Covenants, and Book of Abraham, and 
            church doctrine, 
            why do the Q15 continue to indoctrinate members. Given the dark episodes of Mormon history with its racism, misogyny, and violence, why do the Q15 continue 
            to tell members Mormonism is God’s one true church and spin a faithful narrative? Given the clear lack of prophecy, seership, and revelation, why do the 
            Q15 continue to require 10 percent of members’ money and encourage young men and young women to dedicate two years as missionaries? I could go on.
          </p>
        </div>

        <div className='paragraph'>
          <p>Perhaps they enjoy being the top 15 leaders of a global corporation with members that practically worship them – standing when they enter a room. 
            Mormonism is a culture of ascendancy. Perhaps they enjoy the power of enriching friends and family by assigning church contracts and construction 
            projects around the world. In all seriousness, I hope none of them are that corrupt. And I don’t believe they are. The truth of the matter is that the Q15 
            wants to keep the religion they love alive. 
          </p>
        </div>

        <div className='paragraph'>
          <p>People ask if the Q15 know the issues threatening the church's survival. They absolutely know. As leaders, it is their responsibility to understand the 
            threats to protect the church. In their high positions they are exposed to all the dark and dangerous issues of Mormonism. They see the declining membership 
            and the church dwindling in unbelief. They respond by withholding attendance statistics and creating a home-centered gospel learning program.
          </p>
        </div>

        <div className='paragraph'>
          <p>Perhaps they refuse to acknowledge the truth to themselves. They opt to have a convenient definition of Mormonism in their minds, 
            shutting out all evidence to the contrary. Apologists do the same. They are like the children of Israel when Moses held up the 
            staff with a serpent’s head to heal them. But they would not look.  
            <btn id="clickable10" className="footnote">10 </btn>
            <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>Numbers 21:8-9.</Tooltip> 

            They are like a son of perdition who Joseph Smith described as 
            “… say[ing] that the sun does not shine while he sees it.”
            <btn id="clickable11" className="footnote">11 </btn>
            <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Joseph Smith, King Follett Sermon.</Tooltip> 
            
            Russian novelist Fyodor Dostoevsky wrote: “Above all, don’t lie to yourself. The man who lies to himself and listens to his own lie comes to such a pass that he cannot 
            distinguish the truth within him, or around him.”
          </p>
        </div>

        <div className='paragraph'>
          <p>To keep Mormonism alive, they push a misleading narrative of Mormonism as truth. They ignore historical events and never mention certain essential doctrines once 
            heralded by former prophets, seers, and revelators. In the process, they entice members to misdirect their 
            precious life energies and financial resources to support a failed restoration. 
            Perhaps they rationalize “we are keeping people from bad life choices.” “We’re giving them a good life.” “They seem so happy.”
          </p>
        </div>

        <div className='paragraph'>
          <p>The Mormon church today is a corporation with vast wealth. Perhaps this is how the Q15 convince themselves they are doing Christ’s work by amassing money to build temples. 
            Money gives them power to create the illusion that Zion is prospering and that Christ is behind their work. The members in my wife’s ward believe this. 
            Amassing wealth gives the Q15 something tangible they can do every day when they come into the office; converting the world to Mormonism is clearly not working. 
          </p>
        </div>

        <div className='paragraph'>
          <p>Tragically, much of the Q15’s management of the church is un-Christlike. Their financial fraud using shell companies to keep members paying tithing. 
            Sexual abuse coverups that lead to additional abuse. Deceptive practices in lying to members over historical issues, the size of the church, etc. 
            have caused many to leave. I’m reminded of Christ’s words, “Not everyone that saith unto me, Lord, Lord, shall enter into the kingdom of heaven; but he that doeth the 
            will of my Father which is in heaven.” It’s not too late for church leaders to repent.
          </p>
        </div>

        <div className='paragraph'>
          <p>Jesus stated, “Ye shall know the truth, and the truth shall make you free.”  
          <btn id="clickable12" className="footnote">12 </btn>
          <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>John 8:32.</Tooltip> 
            
            Philosopher Friedrich Nietzsche stated, “The strength of a person’s spirit [is] measured by how much ‘truth’ he 
            could tolerate, or more precisely, to what extent he needs to have it diluted, disguised, sweetened, muted, falsified.”  
            <btn id="clickable13" className="footnote">13 </btn>
            <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Friedrich Nietzsche, Beyond Good and Evil.</Tooltip> 
            
            George Orwell stated, “The Party told you to reject the evidence of your eyes and ears. It was their final, most essential 
            command.”  
            <btn id="clickable14" className="footnote">14 </btn>
            <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>George Orwell, 1984.</Tooltip>  

            Philosopher Henry David Thoreau stated, “Rather than love, than money, than fame, give me truth.”
            <btn id="clickable15" className="footnote">15 </btn>
            <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>Henry David Thoreau, Walden.</Tooltip>  
          </p>
        </div>

        <div className='paragraph'>
          <p>The problem in life for so many people is that if you are not connected to the steel hinge of truth, and willing to pay the price – whatever that price may be – to integrate 
            truth into your life, your mind will align with personal agendas and the noise of belief systems thrust upon you. You will accept false realities. You will wander down strange 
            roads. You will end up wiling away your precious days in a delusion and not fill the measure of your creation.
          </p>
        </div>

        <h2 className="headlinePadding" >Need for a Metaphysic</h2>

        <div className='paragraph'>
          <p>Our existence is a mystery. We are left to our own devices in this strange world to discover its meaning. From time immemorial, the unanswered questions remain the same. 
            Where did my consciousness originate? What am I to do with my days? Is there anything after death? We seek for answers, but if we’re honest, nothing definitive arrives. 
            People need a metaphysic narrative to have peace and purpose — to even make it through life. In the face of our inevitable death, and life’s struggles, we need a story 
            that connects us to something greater. The story we tell ourselves must transcend our everyday lives. And that’s where myth and religion come in to provide that metaphysic. 
          </p>
        </div>

        <div className='paragraph'>
          <p>Some people are willing to provide you with their metaphysic – always with strings attached such as in Mormonism. You must feed the beast. 
            It is easier to simply accept someone else’s view of reality then do the heavy lifting and go on a 
            spiritual journey into the unknown and discover things for yourself. In mythology, the hero confronts the chaotic potential within herself or himself. Overcoming obstacles and 
            defeats, they tame a portion of the chaos and uncertainty inside themselves. They transcend the person that their tribe told them they were to be and their true self emerges. 
            The Greek philosopher Heraclitus stated to be yourself in a world that is constantly trying to make you something else is the greatest accomplishment. 
          </p>
        </div>

        <div className='paragraph'>
          <p>Every individual has their unique light. As an individual, will you permit that light to shine forth? Or will you put it under a bushel of conformity? If you don’t bring that light into 
            the world, the world will be a dimmer place. Psychologist Sigmund Freud wrote, “Don’t impose your notions of one’s destiny upon others. You do not know how that person’s 
            life will unfold.” Unfortunately, that is how modern Mormonism operates.
          </p>
        </div>

        <div className='paragraph'>
          <p>For the brave, life is about the adventure to excellence and truth – to live your best life on your own terms as you desire it. 
          Yes, it is dangerous beyond the safety of the herd as they stare down at the grass chewing, but looking up into the brightness of the sky is where you come into your own and touch and feel freedom.
          </p>
        </div>

        </div>

      <div className="chapterFooter">
        <Link to="/Chap32">Previous</Link>
        <Link to="/">Home</Link>
      </div>


    </div>
  )
}

export default Chap33